import "owl.carousel";

export const CarouselNossesServicos = () => {
  window.addEventListener("load", () => {
    $(".owl-banner-home").owlCarousel({
      loop: true,
      nav: false,
      dots: true,
      items: 1,
    });
    $(".owl-nossos-servicos").owlCarousel({
      loop: true,
      nav: true,
      dots: false,
      stagePadding: 100,
      mouseDrag: false,
      touchDrag: false,
      responsive: {
        0: {
          items: 1,
          stagePadding: 40,
        },
        992: {
          items: 3,
        },
        1245: {
          items: 4,
        },
        1300: {
          items: 5,
        },
      },
    });
    $(".owl-certificacoes").owlCarousel({
      loop: true,
      nav: true,
      stagePadding: 50,
      dots: false,
      responsive: {
        0: {
          items: 1,
        },
        692: {
          items: 3,
        },
        1100: {
          items: 7,
        },
      },
    });
    $(".owl-servicos").owlCarousel({
      loop: true,
      nav: true,
      dots: false,
      margin: 30,
      responsive: {
        0: {
          items: 1,
        },
        991: {
          items: 3,
        },
      },
    });
  });
};

export const OwlBlog = () => {
  $(".owl-blog").owlCarousel({
    loop: true,
    nav: true,
    dots: false,
    responsive: {
      0: {
        items: 1,
        nav: false,
        center: true,
        stagePadding: 40,
      },
      992: {
        items: 2,
      },
      1100: {
        items: 4,
      },
    },
  });
};



// WEBPACK FOOTER //
// ./scripts/components/OwlCrousel.js